<template>
	<div class="container">
		<div class="row align-items-center mt-10 mb-10 row-logo">
			<div class="col mx-auto text-center">
				<img alt="Logo Habilite-se" src="/habil/images/logo.svg" class="h-35px" />
			</div>
		</div>

		<div class="row align-items-center row-card">
			<div class="col-sm-10 col-md-8 mx-auto text-center">
				<div class="card">
					<div class="card-body" style="padding: 26px 0px 26px 0px">
						<div class="text-center mb-10">
							<h2 class="m-0">
								Configuração para assistir aulas online
							</h2>
							<p style="font-size: 15px; color: #747a7e" class="fw-bolder fs-5 text-gray-600">
								Leia com atenção as instruções de cada
								etapa
							</p>
						</div>
						<div class="row justify-content-center">
							<div class="col-md-12">
								<ul id="progressbar">
									<li
										id="check"
										class="fs-5"
										:class="{
											active:
												config_first_license.get_state === 'autorization' ||
												config_first_license.get_state === 'test_mic' ||
												config_first_license.get_state === 'test_webcam',
										}"
									>
										<strong>Autorização</strong>
									</li>
									<li
										id="microphone"
										class="fs-5"
										:class="{
											active: config_first_license.get_state === 'test_mic' ||
													config_first_license.get_state === 'test_webcam',
										}"
									>
										<strong>Microfone</strong>
									</li>
									<li
										id="foto"
										class="fs-5"
										:class="{
												active:
													config_first_license.get_state === 'test_webcam',
										}"
									>
										<strong>Webcam</strong>
									</li>
								</ul>
							</div>
						</div>
						<StartWebcamAndMicrophone v-if="config_first_license.get_state ==='autorization'"/>
						<TestMicrophone v-if="config_first_license.get_state === 'test_mic'"/>
						<TestWebcam v-if=" config_first_license.get_state === 'test_webcam'"/>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import StartWebcamAndMicrophone from '../../components/ConfigFirstLicense/StartWebcamAndMicrophone.vue';
import TestMicrophone from '../../components/ConfigFirstLicense/TestMicrophone.vue';
import TestWebcam from '../../components/ConfigFirstLicense/TestWebcam.vue';
import { configFirstLicenseStore } from '../../stores/configFirstLicense';

const config_first_license = configFirstLicenseStore();

async function startAutorization() {
	const constraints = {
		audio: true,
		video: {
			facingMode: 'user',
		},
	};
	await navigator.mediaDevices
		.getUserMedia(constraints)
		.then((mediaStream) => {
			if (mediaStream.active === true) {
				config_first_license.set_show_button_continue(true);
				localStorage.setItem('config_first_license', Date());
			}
		})
		.catch((error) => {
			config_first_license.set_has_error(true);
			var error_message = error.message;

			if (error_message.search('is not allowed') > 0) {
				config_first_license.set_show_button_error(true);
				config_first_license.set_error_message(
					'É necessario autorizar que a Habilite-se utilize câmera e microfone do aparelho, entre em contato com o suporte.'
				);

				if (localStorage.getItem('config_first_license')) {
					localStorage.removeItem('config_first_license');
				}
				return;
			}
			config_first_license.set_error_message(
				'Não foi possivel configurar o dispositivo, entre em contato com o suporte.'
			);

			mounted_webcam();
			mounted_mic();
		});
}

onMounted(() => {
	config_first_license.set_state('autorization');
	startAutorization();
});

function mounted_webcam() {
	const constraints = {
		video: {
			width: 340,
			height: 120,
		},
	};

	navigator.mediaDevices
		.getUserMedia(constraints)
		.then((mediaStream) => {
			const video = document.querySelector('video');
			if (video === null) {
				throw new Error();
			}
			video.srcObject = mediaStream;
			video.onloadedmetadata = () => {
				video.play();
			};
			config_first_license.set_webcam_configured(true);
		})
		.catch((err) => {
			console.error(`${err.name}: ${err.message}`);
		});
}

function mounted_mic() {
	navigator.mediaDevices
		.getUserMedia({
			audio: true,
		})
		.then(function (stream) {
			const video = document.querySelector('video');
			if (video === null) {
				throw new Error();
			}
			video.srcObject = stream;
			video.onloadedmetadata = () => {
				video.play();
			};
			config_first_license.set_mic_configured(true);
		})
		.catch(function (err) {
			console.error(`${err.name}: ${err.message}`);
		});
}
</script>